import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { LOADING_STATUSES as STATUS } from "constants/common";
import { SupplierPhoneCallsService } from "services/supplier-phone-calls-service";

export const loadPhoneCall = createAsyncThunk(
  "GET_SUPPLIER_PHONE_CALL",
  async (id) => {
    const response = await SupplierPhoneCallsService.getPhoneCall(id);

    return response.data;
  }
);

export const loadPhoneCalls = createAsyncThunk(
  "GET_SUPPLIER_PHONE_CALLS",
  async ({ page, fromNumber, toNumber }) => {
    const dataConfig = {
      params: {
        page,
        per_page: 10,
        from_number: fromNumber || "",
        to_number: toNumber || "",
        include: "support_agent",
        sort_by: "id",
        order: "desc",
      },
    };
    const response = await SupplierPhoneCallsService.getPhoneCalls(dataConfig);

    return response.data;
  }
);

const initialState = {
  error: "",
  status: null,
  phoneCalls: {},
  selectedPhoneCall: null,
  selectedPhoneCallStatus: null,
};

const supplierPhoneCallsSlice = createSlice({
  name: "supplierPhoneCalls",
  initialState,
  reducers: {
    clearSelectedPhoneCall: (state) => {
      state.selectedPhoneCall = null;
      state.selectedPhoneCallStatus = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadPhoneCalls.pending, (state) => {
        state.status = STATUS.loading;
      })
      .addCase(loadPhoneCalls.fulfilled, (state, action) => {
        state.status = STATUS.success;
        state.phoneCalls = action.payload;
      })
      .addCase(loadPhoneCalls.rejected, (state, action) => {
        state.status = STATUS.failed;
        state.error = action.payload;
      })
      .addCase(loadPhoneCall.pending, (state) => {
        state.selectedPhoneCallStatus = STATUS.loading;
      })
      .addCase(loadPhoneCall.fulfilled, (state, action) => {
        state.selectedPhoneCallStatus = STATUS.success;
        state.selectedPhoneCall = action.payload;
      })
      .addCase(loadPhoneCall.rejected, (state, action) => {
        state.selectedPhoneCallStatus = STATUS.failed;
        state.error = action.payload;
      });
  },
});

export const { clearSelectedPhoneCall } = supplierPhoneCallsSlice.actions;

export const getPhoneCallsData = (state) => state.supplierPhoneCalls.phoneCalls;
export const getPhoneCallsStatus = (state) => state.supplierPhoneCalls.status;
export const getSelectedPhoneCall = (state) =>
  state.supplierPhoneCalls.selectedPhoneCall;
export const getSelectedPhoneCallStatus = (state) =>
  state.supplierPhoneCalls.selectedPhoneCallStatus;

export default supplierPhoneCallsSlice.reducer;
